export const COLUMNS = [
    {
        Header: "Subject",
        Footer: "Subject",
        accessor: "subject",
        sticky: "left",
    },
    {
        Header: "Description",
        Footer: "Description",
        accessor: "description",
    },
    {
        Header: "Date",
        Footer: "Date",
        accessor: "createdAt",
    },
    {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
    },
];